import { User, LogOut } from "lucide-react";
import { getRoleDisplayName } from "../../config/navigation";
import logo from "../../assets/logos.jpg";
import NotificationBell from "./NotificationBell";

const Header = ({ currentUser, activeProject, onLogout, onNotificationNavigate }) => {
  return (
    <header className="bg-orange-400 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        {/* Make header stack on mobile, row on larger screens */}
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-2 sm:gap-3 justify-center sm:justify-start">
            <img
              src={logo}
              alt="SmokyQ Icon"
              className="w-10 h-10 sm:w-[45px] sm:h-[45px] rounded-md flex-shrink-0"
            />
            <div className="text-center sm:text-left">
              <h1 className="text-xl sm:text-2xl font-bold text-black leading-tight">
                SmokyQ
              </h1>
              <p className="text-xs sm:text-sm text-black leading-snug">
                {activeProject
                  ? `Project: ${activeProject.name}`
                  : "QA/QC Management System"}
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
            <div className="text-center sm:text-right text-black">
              <p className="text-xs sm:text-sm font-semibold">
                Smoky Hill Engineering LLC
              </p>
              <p className="text-[11px] sm:text-xs">Effective QA/QC Solution</p>
              <p className="text-[11px] sm:text-xs mt-1">
                System Access: {getRoleDisplayName(currentUser?.role)}
              </p>
            </div>
            <NotificationBell onNotificationNavigate={onNotificationNavigate} />

            <div className="flex flex-row items-center justify-center sm:justify-end gap-2 flex-wrap">
              <div className="flex items-center gap-2 bg-black/10 px-3 py-1 rounded-full">
                <User className="w-4 h-4 text-black" />
                <span className="text-xs sm:text-sm text-black">
                  {currentUser?.first_name || "User"}
                </span>
              </div>
              <button
                onClick={onLogout}
                className="w-auto sm:w-auto px-3 sm:px-4 py-1.5 sm:py-2 bg-black text-white rounded text-xs sm:text-sm flex items-center justify-center hover:bg-gray-800"
              >
                <LogOut className="w-4 h-4 mr-1" />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
